import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppSettings } from '../app-settings';
import { showMaintenanceScreen } from '../main-core/maintenance-screen';

/* Maintenance can start while a tab is already open, in which case the APP_INITIALIZER
** check has long since passed and every in-flight call starts failing. Any 503 from the
** API means the maintenance gate (app) or the deploy rewrite rule (IIS) is on, so show
** the banner instead of leaving the user with a spinner. */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {

	constructor(private appSettings: AppSettings) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((err: any) => {
				if (err instanceof HttpErrorResponse && err.status === 503) {
					showMaintenanceScreen(this.appSettings.APIURL);
				}
				return throwError(() => err);
			})
		);
	}
}
